import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

import PayoutManagement from '../../../components/siteadmin/PayoutManagement/PayoutManagement'

import s from "./ManagePayout.css";

const ManagePayout = () => {

    const [state, setState] = useState({ currentPage: 1, searchList: '' });

    const setStateVariable = (variables) => {
        setState(prev => ({
            ...prev,
            ...variables
        }));
    };

    const { currentPage, searchList } = state;
    return <PayoutManagement
        currentPage={currentPage}
        searchList={searchList}
        setStateVariable={setStateVariable} />

}

export default compose(withStyles(s))(ManagePayout);